import { ProductDoc } from '@gooduncles/gu-app-schema';
import useSWR from 'swr';

import { getProduct } from 'src/utils/firebase/firebase-short-cut';

const useProductById = (id: ProductDoc['_id']) => {
  const {
    data,
    isValidating: productLoading,
    error: productError,
  } = useSWR(id ? id : null, getProduct, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    product: data,
    productLoading,
    productError,
  };
};

export default useProductById;
